import { Box, Grid } from "@mui/material";
import { MainContext } from "common/interfaces/MainContext";
import React from "react";
import { NavigateFunction } from "react-router";
import { Info } from "../subComponents/Info";
import { Links } from "../subComponents/Links";
import { Logo } from "../subComponents/Logo";
import { Menu } from "../subComponents/Menu";
import styles from "./MiddleHomePageContent.module.scss";

export const MiddleHomePageContent = React.memo(
  (props: {
    mainContext: MainContext;
    estatesCount: number;
    navigate: NavigateFunction;
    onRequestInputDialogOpen: () => void;
  }) => {
    const { mainContext, navigate, estatesCount } = props;

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box className={styles.top}>
            <Logo styles={styles} />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box className={styles.middle}>
            <Info styles={styles} mainContext={mainContext} />
            <Menu
              styles={styles}
              navigate={navigate}
              onRequestInputDialogOpen={props.onRequestInputDialogOpen}
              estatesCount={estatesCount}
            />
          </Box>
        </Grid>
        <Grid size={12}>
          <Box className={styles.bottom}>
            <Links
              styles={styles}
              navigate={navigate}
              mainContext={mainContext}
            />
          </Box>
        </Grid>
      </Grid>
    );
  }
);
